export default "__VITE_ASSET__DuLbExl2__"